import clsx from 'clsx';
import { useState } from 'preact/hooks';

import { AnimalAlertPopover, AnimalAlertTriggerButton, useAnimalAlert } from '@/components/AnimalAlertButtons';
import { isPhone } from '@/helpers';

import RecordVideoButton from './RecordVideoButton';
import style from './style.scss';
import TakeSnapshotButton from './TakeSnapshotButton';
import ZoomBar from './ZoomBar';

const StreamControls = ({ position = 'left', isFullscreen = false, habitatId, cameraId }) => {
  const [popoverOpen, setPopoverOpen] = useState(false);
  const { emitAnimalAlert, flaggedAlertType } = useAnimalAlert({
    habitatId,
    cameraId,
    entryPoint: 'habitat-stream',
  });

  return (
    <div className={clsx(style.streamControlsWrapper, style[position])}>
      <div className={style.streamControls}>
        <ZoomBar width="36px" height="190px" />

        {(!isPhone() || !isFullscreen) && (
          <>
            <div className="relative">
              <AnimalAlertTriggerButton onClick={() => setPopoverOpen((open) => !open)} />
              <AnimalAlertPopover
                open={popoverOpen}
                disabled={!!flaggedAlertType}
                habitatId={habitatId}
                className="absolute bottom-0 left-[60px]"
                onClose={() => setPopoverOpen(false)}
                onSelect={emitAnimalAlert}
              />
            </div>
            <div className={style.snapshots}>
              <TakeSnapshotButton />
              <RecordVideoButton />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default StreamControls;
